import ApplicationService from "@/services/application.service";
import { StorageService } from "@/services/storage.service";

const state = () => ({
  list: [],
  page: 1,
  orderBy: "new",
  filters: "",
  date: "",
  id: "",
  pkKundeExcId: "",
  page_count: 50,
  selected: StorageService.get("application") || {}
});

const getters = {
  list: state => state.list,
  orderBy: state => state.orderBy,
  filters: state => state.filters,
  date: state => state.date,
  selected: state => state.selected,
  id: state => state.id,
  pkKundeExcId: state => state.pkKundeExcId,
};

const actions = {
  list({ commit, state }) {
    return ApplicationService.fetchList(
      state.page,
      state.orderBy,
      state.filters,
      state.date,
      state.page_count
    )
      .then(res => {
        commit("setList", res.data);
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  apply({ commit, state }, params) {
    return ApplicationService.apply(params)
      .then(() => true)
      .catch(err => {
        let str = "";
        if (err.response.data.constructor === String) {
          str = err.response.data;
        } else {
          str =
            err.response.data.errors[
            Object.keys(err.response.data.errors)[0]
            ][0];
        }
        return str;
      });
  },
  reject({ commit, state }, offerId) {
    return ApplicationService.reject(offerId)
      .then(() => true)
      .catch(() => true);
  },
  revoke({ commit }, id) {
    return ApplicationService.revoke(id)
      .then(res => {
        commit("pkKundeExcId", res.data);
        return true;

      })
      .catch((error) => {return error});
  },
  showFamily({ state }) {
    return ApplicationService.showFamily(state.pkKundeExcId)
      .then(() => {
        return true;
      })
      .catch((error) => false);
  },

};

const mutations = {
  setList(state, data) {
    state.list = data;
  },
  setOrderBy(state, data) {
    state.orderBy = data;
  },
  setFilters(state, data) {
    state.filters = data;
  },
  setDate(state, data) {
    state.date = data;
  },
  setSelected(state, data) {
    state.selected = data;
    StorageService.save("application", JSON.stringify(data));
  },

  pkKundeExcId(state, data) {
    state.pkKundeExcId = data.pkKundeExcId
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
